//@flow
import { urlsConstants } from "./../_constants/urls.constant";
import { defaultService } from "./defaultService";

export const doencaService = {
  findByNome
};

function findByNome(nome: string) {
  return defaultService.doGet(`${urlsConstants.DOENCA}findByNome/${nome}`);
}
